import { MEMBERS, IMPLICIT_GENDER, emptyInsuredForMember } from "../wizardUtils";
import { User, Users, Baby, Heart } from "lucide-react";

const ICONS = {
  self: User,
  wife: Heart,
  son: Baby,
  daughter: Baby,
  father: Users,
  mother: Users,
};

export default function MemberSelection({ state, setState, errors }) {
  const toggle = (key) => {
    setState((s) => {
      const has = s.selectedMembers.includes(key);
      const selectedMembers = has
        ? s.selectedMembers.filter((m) => m !== key)
        : [...s.selectedMembers, key];
      const insured = { ...s.insured };
      if (!has && !insured[key]) {
        insured[key] = emptyInsuredForMember(key);
      }
      return { ...s, selectedMembers, insured };
    });
  };

  return (
    <div data-testid="wizard-step-members">
      <h2 className="text-3xl sm:text-4xl font-medium tracking-tight mb-2">
        Who would you like to insure?
      </h2>
      <p className="text-secondary-brand mb-8 leading-relaxed">
        Select all family members you&apos;d like to include. You can pick more than
        one.
      </p>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {MEMBERS.map(({ key, label }) => {
          const Icon = ICONS[key] || User;
          const active = state.selectedMembers.includes(key);
          return (
            <button
              key={key}
              type="button"
              onClick={() => toggle(key)}
              className={`member-card ${active ? "active" : ""}`}
              data-testid={`member-card-${key}`}
              aria-pressed={active}
            >
              <div className="member-icon-wrapper">
                <Icon size={28} strokeWidth={1.5} />
              </div>
              <span className="text-base font-semibold">{label}</span>
              {IMPLICIT_GENDER[key] && (
                <span className="text-xs uppercase tracking-widest text-muted-brand">
                  {IMPLICIT_GENDER[key]}
                </span>
              )}
            </button>
          );
        })}
      </div>

      {errors.selectedMembers && (
        <p className="error-text mt-4" data-testid="error-members">
          {errors.selectedMembers}
        </p>
      )}
    </div>
  );
}
